/**
 * Pylon 3 right leg — display names for monitor charts.
 */
import { buildDefaultStrainLabels } from '../../utils/sensorDisplayName';

export const SENSOR_LABELS = {
  ...buildDefaultStrainLabels(17),
};
